import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadUserListEpic } from './_epics/loadUserList.epic';
import { reloadUserListEpic } from './_epics/reloadUserList.epic';
import { loadClientUserListEpic } from './_epics/loadClientUserList.epic';
import { reloadClientUserListEpic } from './_epics/reloadClientUserList.epic';
import { removeUser } from './_epics/removeUser.epic';
import { removeClientUser } from './_epics/removeClientUser.epic';

export const userListEpic = safeCombineEpics(
  loadUserListEpic,
  reloadUserListEpic,
  removeUser,
);

export const clientUserListEpic = safeCombineEpics(
  loadClientUserListEpic,
  reloadClientUserListEpic,
  removeClientUser,
);
